import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthPSCResolve implements Resolve<any> {
  constructor(private authService: AuthService, private router: Router) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const { code } = route.queryParams;

    if (!code) {
      try {
        const { token } = this.authService.getCurrentUser();

        return await firstValueFrom(this.authService.listUserPsc(token));
      } catch (error) {
        this.router.navigate(['/login'], { queryParams: { expire: true } });

        return;
      }
    }

    const { user, token, permissions } = await firstValueFrom(this.authService.connectPsc(code));

    if (user) {
      this.authService.putCookieUser({ ...user, token }, permissions);
      this.authService.redirectUser(user);

      return;
    }

    this.authService.putCookieUser({ token });
    this.router.navigate(['/pscAuth'], { queryParams: { firstAccount: true } });
  }
}
